import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    const [timedOut, setTimedOut] = useState(false);

    useEffect(() => {
        if (!loading) return;
        const id = setTimeout(() => setTimedOut(true), 5000);
        return () => clearTimeout(id);
    }, [loading]);

    if (loading && !timedOut) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="text-muted-foreground font-body" data-testid="auth-loading">Chargement…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/auth/signin" replace state={{ from: location }} />;
    }
    return children;
}
